import { useState } from "react";
import { useTranslation } from "react-i18next";

export const Inputs = () => {
    const { t } = useTranslation();
    const [formValues] = useState(
        [
            [
                { label: `${t("page")}`, col: 6, key: "pagetr", type: "text" },
                { label: `${t("page")} (EN)`, col: 6, key: "pageen", type: "text" },
                { label: `${t("slug")}`, col: 6, key: "slugtr", type: "text" },
                { label: `${t("slug")} (EN)`, col: 6, key: "slugen", type: "text" },
                { label: `${t("banner_text")}`, col: 6, key: "nametr", type: "text" },
                { label: `${t("banner_text")} (EN)`, col: 6, key: "nameen", type: "text" },
                { label: `${t("title")}`, col: 6, key: "titletr", type: "text" },
                { label: `${t("title")} (EN)`, col: 6, key: "titleen", type: "text" },
                { label: `${t("content")}`, col: 12, key: "contenttr", type: "ck" },
                { label: `${t("content")} (EN)`, col: 12, key: "contenten", type: "ck" },
            ],
            [
                { label: `${t("page")}`, col: 6, key: "pagetr", type: "text" },
                { label: `${t("page")} (EN)`, col: 6, key: "pageen", type: "text" },
                { label: `${t("slug")}`, col: 6, key: "slugtr", type: "text" },
                { label: `${t("slug")} (EN)`, col: 6, key: "slugen", type: "text" },
                { label: `${t("banner_text")}`, col: 6, key: "nametr", type: "text" },
                { label: `${t("banner_text")} (EN)`, col: 6, key: "nameen", type: "text" },
                { label: `${t("title")}`, col: 4, key: "titletr", type: "text" },
                { label: `${t("title")} (EN)`, col: 4, key: "titleen", type: "text" },
                { label: `${t("line_count")}`, col: 4, key: "lineCount", type: "number" },
            ],
            [
                { label: `${t("page")}`, col: 6, key: "pagetr", type: "text" },
                { label: `${t("page")} (EN)`, col: 6, key: "pageen", type: "text" },
                { label: `${t("slug")}`, col: 6, key: "slugtr", type: "text" },
                { label: `${t("slug")} (EN)`, col: 6, key: "slugen", type: "text" },
                { label: `${t("banner_text")}`, col: 6, key: "nametr", type: "text" },
                { label: `${t("banner_text")} (EN)`, col: 6, key: "nameen", type: "text" },
                { label: `${t("title")}`, col: 4, key: "titletr", type: "text" },
                { label: `${t("title")} (EN)`, col: 4, key: "titleen", type: "text" },
                { label: `${t("line_count")}`, col: 4, key: "lineCount", type: "number" },
            ],
            [
                { label: `${t("page")}`, col: 6, key: "pagetr", type: "text" },
                { label: `${t("page")} (EN)`, col: 6, key: "pageen", type: "text" },
                { label: `${t("slug")}`, col: 6, key: "slugtr", type: "text" },
                { label: `${t("slug")} (EN)`, col: 6, key: "slugen", type: "text" },
                { label: `${t("image")}`, col: 12, key: "file", type: "file" },
                { label: `${t("banner_text")}`, col: 6, key: "nametr", type: "text" },
                { label: `${t("banner_text")} (EN)`, col: 6, key: "nameen", type: "text" },
                { label: `${t("title")}`, col: 6, key: "titletr", type: "text" },
                { label: `${t("title")} (EN)`, col: 6, key: "titleen", type: "text" },
                { label: `${t("content")}`, col: 12, key: "contenttr", type: "ck" },
                { label: `${t("content")} (EN)`, col: 12, key: "contenten", type: "ck" },
            ],
        ]
    );
    return formValues
}

export const GroupInputs = () => {
    const { t } = useTranslation();
    const [formValues] = useState(
        [
            [

            ],
            [
                { label: t("image"), col: 6, key: "file1", type: "file" },
                { label: t("icon"), col: 6, key: "file2", type: "file" },
                { label: `${t("field")}`, col: 6, key: "descriptiontr", type: "text" },
                { label: `${t("field")} (EN)`, col: 6, key: "descriptionen", type: "text" },
                { label: `${t("title")}`, col: 6, key: "titletr", type: "text" },
                { label: `${t("title")} (EN)`, col: 6, key: "titleen", type: "text" },
            ],
            [
                { label: t("image"), col: 12, key: "file", type: "file" },
            ],
            [
                { label: t("image"), col: 12, key: "file", type: "file" },
                { label: t("slug"), col: 12, key: "slug", type: "text" },
            ],
        ]
    );
    return formValues
}